"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutCurrencies = exports.PaymentCurrencies = exports.CurrencyEnumCurrencyIso = exports.IsoCurrencyCurrencyEnum = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency[Currency["Euro"] = 0] = "Euro";
    Currency[Currency["Dollar"] = 1] = "Dollar";
    Currency[Currency["AustralianDollar"] = 2] = "AustralianDollar";
    Currency[Currency["CanadianDollar"] = 3] = "CanadianDollar";
    Currency[Currency["BritishPound"] = 4] = "BritishPound";
    Currency[Currency["NewZealandDollar"] = 5] = "NewZealandDollar";
    Currency[Currency["CzechKoruna"] = 6] = "CzechKoruna";
    Currency[Currency["MexicanPeso"] = 7] = "MexicanPeso";
})(Currency || (exports.Currency = Currency = {}));
exports.IsoCurrencyCurrencyEnum = {
    eur: Currency.Euro,
    usd: Currency.Dollar,
    aud: Currency.AustralianDollar,
    cad: Currency.CanadianDollar,
    gbp: Currency.BritishPound,
    nzd: Currency.NewZealandDollar,
    czk: Currency.CzechKoruna,
    mxn: Currency.MexicanPeso,
};
exports.CurrencyEnumCurrencyIso = {
    [Currency.Euro]: "eur",
    [Currency.Dollar]: "usd",
    [Currency.AustralianDollar]: "aud",
    [Currency.CanadianDollar]: "cad",
    [Currency.BritishPound]: "gbp",
    [Currency.NewZealandDollar]: "nzd",
    [Currency.CzechKoruna]: "czk",
    [Currency.MexicanPeso]: "mxn",
};
exports.PaymentCurrencies = [
    Currency.Euro,
    Currency.Dollar,
    Currency.AustralianDollar,
    Currency.CanadianDollar,
    Currency.BritishPound,
    Currency.NewZealandDollar,
];
exports.PayoutCurrencies = [Currency.Euro, Currency.Dollar];
//# sourceMappingURL=Currency.js.map